import React, { useEffect } from 'react';
import Header from '../../../Header';
import Footer from '../../../Footer';
import Banner from '../../Banner';
import { Link, useLocation } from 'react-router-dom';

const GizlilikKullanim: React.FC = () => {
  const location = useLocation();
  const language = location.pathname.startsWith('/en') ? 'en' : 'tr';
  const lang: 'en' | 'tr' = language;

  const setLanguage = (newLang: 'en' | 'tr') => {
    let newPath = location.pathname;
    if (newLang === 'en' && !newPath.startsWith('/en')) {
      newPath = '/en' + (newPath.startsWith('/tr') ? newPath.slice(3) : newPath);
    } else if (newLang === 'tr' && !newPath.startsWith('/tr')) {
      newPath = '/tr' + (newPath.startsWith('/en') ? newPath.slice(3) : newPath);
    }
    window.location.href = newPath;
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const breadcrumb = (
    <>
      <Link to={`/${lang}`} className="text-gray-400 font-bold">{lang === 'tr' ? 'Ana Sayfa' : 'Home'}</Link>
      <span className="text-gray-400 font-bold">/</span>
      <Link to={`/${lang}/about/certification`} className="text-gray-400 font-bold">{lang === 'tr' ? 'Sertifikasyon ve Dökümantasyon' : 'Certification & Documentation'}</Link>
      <span className="text-gray-400 font-bold">/</span>
      <Link to={`/${lang}/about/certification/documents`} className="text-gray-400 font-bold">{lang === 'tr' ? 'Dökümantasyon' : 'Documentation'}</Link>
      <span className="text-gray-400 font-bold">/</span>
      <span className="text-white font-bold">{lang === 'tr' ? 'Gizlilik Sözleşmesi Ve Kullanım Hakları' : 'Confidentiality Agreement & Usage Rights'}</span>
    </>
  );

  return (
    <div>
      <Header language={lang} setLanguage={setLanguage} />
      <Banner
        title={lang === 'tr' ? 'Gizlilik Sözleşmesi Ve Kullanım Hakları' : 'Confidentiality Agreement & Usage Rights'}
        description={lang === 'tr' ? 'Gizlilik ve kullanım haklarına dair esaslar.' : 'Principles regarding confidentiality and usage rights.'}
        breadcrumb={breadcrumb}
      />
      <div className="bg-white py-16">
        <div className="max-w-4xl mx-auto px-6">
          {lang === 'tr' ? (
            <div className="space-y-8">
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Genel Hükümler</h3>
                <p className="text-gray-700 leading-relaxed">Bu sayfa, CG Teknoloji'nin sunduğu hizmetler ile web sitesi içeriklerinin kullanımına ilişkin gizlilik yükümlülüklerini ve kullanım haklarını düzenlemektedir. Sitemizi kullanan her kişi bu koşulları okumuş ve kabul etmiş sayılır.</p>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Fikri Mülkiyet Hakları</h3>
                <p className="text-gray-700 leading-relaxed">Web sitemizde yer alan tüm metin, görsel, grafik, logo ve içerikler CG Teknoloji'ye aittir ve 5846 sayılı Fikir ve Sanat Eserleri Kanunu kapsamında korunmaktadır. Önceden yazılı izin alınmaksızın kopyalanamaz, çoğaltılamaz, değiştirilemez veya ticari amaçla kullanılamaz.</p>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Gizlilik Yükümlülükleri</h3>
                <p className="text-gray-700 leading-relaxed">CG Teknoloji ile iş ilişkisi sürecinde edinilen her türlü ticari, teknik veya kişisel bilgi gizlidir. Taraflar, bu bilgileri üçüncü kişilerle paylaşmamayı, yalnızca ilgili amaç dahilinde kullanmayı ve iş ilişkisi sona erdikten sonra da bu yükümlülüğe uymayı taahhüt eder.</p>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Hizmetlerin Kullanımı</h3>
                <p className="text-gray-700 leading-relaxed">Hizmetlerimiz yalnızca yasal amaçlarla kullanılabilir. Sisteme zarar verici, yanıltıcı, hakaret içerikli veya hukuka aykırı her türlü kullanım yasaktır. CG Teknoloji, hizmet koşullarını ihlal eden kullanıcıların erişimini önceden bildirimde bulunmaksızın askıya alma veya sonlandırma hakkını saklı tutar.</p>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Sorumluluk Sınırlaması</h3>
                <p className="text-gray-700 leading-relaxed">CG Teknoloji, web sitesindeki bilgilerin doğruluğu ve güncelliği için gerekli özeni göstermekle birlikte, içeriklerdeki hatalar veya güncel olmayan bilgiler nedeniyle doğabilecek zararlardan sorumlu tutulamaz. Üçüncü taraf bağlantılarının içeriğinden sorumluluk kabul edilmez.</p>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Değişiklikler</h3>
                <p className="text-gray-700 leading-relaxed">Bu koşullar önceden bildirim yapılmaksızın güncellenebilir. Güncel hali daima bu sayfa üzerinden yayınlanacaktır. Hizmetlerin kullanımına devam edilmesi, güncellenmiş koşulların kabul edildiği anlamına gelir.</p>
              </section>
            </div>
          ) : (
            <div className="space-y-8">
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">General Provisions</h3>
                <p className="text-gray-700 leading-relaxed">This page governs the confidentiality obligations and usage rights relating to the services provided by CG Teknoloji and the use of website content. Any person using our website is deemed to have read and accepted these terms.</p>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Intellectual Property Rights</h3>
                <p className="text-gray-700 leading-relaxed">All text, visuals, graphics, logos, and content on our website belong to CG Teknoloji and are protected under the Intellectual and Artistic Works Law No. 5846. They may not be copied, reproduced, modified, or used for commercial purposes without prior written permission.</p>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Confidentiality Obligations</h3>
                <p className="text-gray-700 leading-relaxed">Any commercial, technical, or personal information acquired during a business relationship with CG Teknoloji is confidential. The parties undertake not to share such information with third parties, to use it only for the relevant purpose, and to maintain this obligation even after the business relationship ends.</p>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Use of Services</h3>
                <p className="text-gray-700 leading-relaxed">Our services may only be used for lawful purposes. Any use that is harmful to the system, misleading, defamatory, or contrary to law is prohibited. CG Teknoloji reserves the right to suspend or terminate access of users who violate the terms of service without prior notice.</p>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Limitation of Liability</h3>
                <p className="text-gray-700 leading-relaxed">While CG Teknoloji exercises due care to ensure the accuracy and currency of information on the website, it cannot be held liable for damages arising from errors or outdated information. No responsibility is accepted for the content of third-party links.</p>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Changes</h3>
                <p className="text-gray-700 leading-relaxed">These terms may be updated without prior notice. The current version will always be published on this page. Continued use of the services constitutes acceptance of the updated terms.</p>
              </section>
            </div>
          )}
        </div>
      </div>
      <Footer language={lang} />
    </div>
  );
};

export default GizlilikKullanim; 